import { AppContext } from 'next/app';

import { Locale } from './types';

export function initLocaleServerApp(appContext: AppContext): void {
  if (appContext.ctx.locale && !(appContext.ctx.locale in Locale)) {
    throw new Error('locale is invalid, initLocaleServerApp can not continue');
  }

  Object.assign(appContext.ctx.req!, {
    locale: appContext.ctx.locale || Locale.nl,
  });
}
